import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import loadable from '@loadable/component';

import { sendVerificationEmail, hasCurrentUserErrors } from '../../ducks/user.duck';
import { authenticationInProgress } from '../../ducks/auth.duck';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { logout as apiLogout } from '../../api/auth';

const Topbar = loadable(() => import(/* webpackChunkName: "Topbar" */ './Topbar/Topbar'));

/**
 * Topbar container component, which is connected to Redux Store.
 */
export const TopbarContainerComponent = props => {
  const {
    notificationCount = 0,
    hasGenericError,
    showSearchForm,
    location,
    currentPage,
    ...rest
  } = props;

  const buyerOnlyOverrides = {
    currentUserHasListings: false,
    showCreateListingsLink: false,
  };

  const pathname = location?.pathname || '';
  const isSearchRoute = pathname === '/s' || pathname.startsWith('/s/');
  const isLandingRoute = pathname === '/' || pathname.startsWith('/');

  const resolvedShowSearchForm =
    isSearchRoute || isLandingRoute || typeof showSearchForm === 'boolean'
      ? isSearchRoute || isLandingRoute || showSearchForm
      : true;

  return (
    <Topbar
      notificationCount={notificationCount}
      showGenericError={hasGenericError}
      showSearchForm={resolvedShowSearchForm}
      currentPage={currentPage}
      {...rest}
      {...buyerOnlyOverrides}
    />
  );
};

const mapStateToProps = state => {
  const { isAuthenticated, isLoggedInAs, logoutError, authScopes } = state.auth;

  const {
    currentUser,
    currentUserHasOrders,
    currentUserOrderNotificationCount = 0,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
  } = state.user;

  const hasGenericError = !!(logoutError || hasCurrentUserErrors(state));

  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    currentUserHasListings: false,
    currentUserHasOrders,
    notificationCount: currentUserOrderNotificationCount,
    isAuthenticated,
    isLoggedInAs,
    authScopes,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    hasGenericError,
  };
};

const mapDispatchToProps = dispatch => ({
  onLogout: async () => {
    await apiLogout();
    window.location.href = '/login';
  },
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
});

const TopbarContainer = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(TopbarContainerComponent);

export default TopbarContainer;